import { useQuery } from '@tanstack/react-query';
import endpoints from '../endpoints.ts';
import api from '../api/index.ts';

export const CUSTOMER_LOCATION_QUERY_KEY = 'CUSTOMER_LOCATION_QUERY_KEY';

const useReadAllByUserId = () =>
  useQuery({
    queryKey: [
      CUSTOMER_LOCATION_QUERY_KEY,
      endpoints.customerLocation.read.all.by.userId(),
    ],
    queryFn: api.customerLocation.read.all.by.userId,
  });

const useReadAllHydratedByUserId = () =>
  useQuery({
    queryKey: [
      CUSTOMER_LOCATION_QUERY_KEY,
      endpoints.customerLocation.read.all.hydrated.by.userId(),
    ],
    queryFn: api.customerLocation.read.all.hydrated.by.userId,
  });

const customerLocationQueryHooks = {
  useReadAllByUserId,
  useReadAllHydratedByUserId,
};

export default customerLocationQueryHooks;
